const CopyDocumentsFormTestIdsScope = {
  COPY_DOCUMENTS_FORM: 'copy-documents-form',
};

export const CopyDocumentsFormTestIds = {
  TARGET_LOAN_SELECT: `${CopyDocumentsFormTestIdsScope.COPY_DOCUMENTS_FORM}.target-loan-select`,
};
